import React, { useState } from 'react';
import { healthcareInvoicesApi } from '../services/api';

export default function InvoicePrintDetails({ invoice, onSaved }) {
  const [editing, setEditing] = useState(false);
  const [description, setDescription] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [saved, setSaved] = useState(false);
  const save = async event => {
    event.preventDefault(); setBusy(true); setError('');
    try {
      const result = await healthcareInvoicesApi.savePrintDetails(invoice.id, { description: description.trim() });
      onSaved(result); setEditing(false); setSaved(true);
    } catch (e) { setError(e.message || 'Dettagli non salvati.'); }
    finally { setBusy(false); }
  };
  return <div className="invoice-print-details">
    {!editing ? <><button type="button" className="clinic-button secondary" onClick={() => { setDescription(invoice.description || ''); setEditing(true); setSaved(false); }}>Modifica dettagli</button>{saved && <p role="status">Descrizione salvata. Il prossimo PDF conterrà il testo aggiornato.</p>}</> :
      <form onSubmit={save}>
        <label>Descrizione della prestazione<textarea rows="3" maxLength="180" required value={description} onChange={e => setDescription(e.target.value)} disabled={busy}/></label>
        <p>Indirizzo destinatario: {invoice.buyerAddress || 'Completa la scheda paziente e aggiorna la pagina.'}</p>
        <small>Modifica la dicitura della prestazione, senza inserire diagnosi o note cliniche. Numero, importi e invio TS restano invariati.</small>
        {error && <p role="alert">{error}</p>}
        <div className="billing-buttons"><button className="clinic-button" disabled={busy || !description.trim()}>{busy ? 'Salvataggio…' : 'Salva dettagli'}</button><button type="button" className="clinic-button secondary" disabled={busy} onClick={() => setEditing(false)}>Annulla</button></div>
      </form>}
  </div>;
}
